import { render, staticRenderFns } from "./lesson-plan-version-select.vue?vue&type=template&id=0a9e3763"
import script from "./lesson-plan-version-select.ts?vue&type=script&lang=ts&external"
export * from "./lesson-plan-version-select.ts?vue&type=script&lang=ts&external"
import style0 from "./lesson-plan-version-select.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports